import { ExclamationTriangleIcon, XMarkIcon } from '@heroicons/react/24/outline';
import React from 'react';

export interface ErrorBannerProps {
    tone: 'amber' | 'red';
    message: string;
    onDismiss: () => void;
}

export const ErrorBanner: React.FC<ErrorBannerProps> = ({ tone, message, onDismiss }) => (
    <div
        className={`flex items-center gap-2 rounded-lg px-4 py-2.5 border ${
            tone === 'amber' ? 'bg-amber-50 border-amber-200' : 'bg-red-50 border-red-200'
        }`}
    >
        <ExclamationTriangleIcon
            className={`w-4 h-4 flex-shrink-0 ${tone === 'amber' ? 'text-amber-600' : 'text-red-600'}`}
        />
        <span className={`text-xs flex-1 ${tone === 'amber' ? 'text-amber-800' : 'text-red-800'}`}>
            {message}
        </span>
        <button
            onClick={onDismiss}
            className={`transition-colors ${
                tone === 'amber'
                    ? 'text-amber-600 hover:text-amber-800'
                    : 'text-red-600 hover:text-red-800'
            }`}
            aria-label="Dismiss error"
        >
            <XMarkIcon className="w-4 h-4" />
        </button>
    </div>
);
